<template>
  <el-container class="personal_center_container">
    <el-header height="65px">
        <personal_center_header/>
    </el-header>
    <el-main>
      <div class="personal_center">
        <router-view></router-view>
      </div>
    </el-main>
    <el-footer height="240px">
        <myFooter />
    </el-footer>
  </el-container>

  <!--    <router-link to="/basic_info">基础信息</router-link>-->
  <!--    <br />-->
  <!--    <router-link to="/main_body_management">主体管理</router-link>-->
  <!--    <br />-->
  <!--    <router-link to="/send_address">寄送地址</router-link>-->
  <!--    <br />-->
  <!--    <router-link to="/change_psw">修改密码</router-link>-->
  <!--    <br />-->
  <!--    <router-link to="/real_name_authentication">实名认证</router-link>-->
  <!--    <br />-->
  <!--    <router-link to="/my_wallet">我的钱包</router-link>-->
  <!--    <br />-->
  <!--    <router-link to="/my_order">我的订单</router-link>-->
  <!--    <br />-->
  <!--    <router-link to="/order_to_be_paid">待支付</router-link>-->
  <!--    <br />-->
  <!--    <router-link to="/order_to_be_evaluated">待评价</router-link>-->
  <!--    <br />-->
  <!--    <router-link to="/order_completed">已完成</router-link>-->
  <!--    <br />-->
  <!--    <router-link to="/order_have_in_hand">进行中</router-link>-->
  <!--    <router-view></router-view>-->
</template>

<script>
import personal_center_header from "@/components/personal_center_header.vue";
import myFooter from "@/components/myFooter.vue";
import headLogo from '@/assets/img/head/headLogo.png'
export default {
  components:{personal_center_header,myFooter},
  data() {
    return {
      logo: headLogo,
    };
  },
};
</script>

<style lang="scss" scoped>
.personal_center_container{
  min-height: 100vh;
}
.personal_center {
  .logo_box{
    width: 200px;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .logo {
    display: block;
    width: 58px;
    height: 33px;
    img{
      width: 100%;
    }
  }
  .main_t{
    background: #fff;
  }
  .main {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    background: #fff;
  }
  .main_l {
    h2 {
      width: 133px;
      align-self: center;
      margin-right: 40px;
    }
    img {
      width: 100%;
    }
    ul {
      min-width: 300px;
      align-items: center;
    }
    li {
      padding: 0 20px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
    li > a {
      display: inline-block;
      width: 100%;
      height: 100%;
      color: #333;
      font-size: 20px;
      font-weight: 700;
    }
    li:hover a {
      color: #777;
    }
    li.active:hover a {
      color: #333;
    }
    li.active {
      border-bottom: 3px solid #ff9800;
    }
  }
  .main_l,
  .main_l ul,
  .main_r,
  .search_box {
    display: flex;
    flex-wrap: nowrap;
  }
  .main_r {
    justify-content: space-between;
  }
  .main_r,
  .search_box {
    align-items: center;
  }
  .ml10 {
    margin-left: 10px !important;
  }
  .el-select .el-input {
    width: 104px !important;
  }
  .el-input-group__append button.el-button,
  .el-input-group__append div.el-select .el-input__inner,
  .el-input-group__append div.el-select:hover .el-input__inner,
  .el-input-group__prepend button.el-button,
  .el-input-group__prepend div.el-select .el-input__inner,
  .el-input-group__prepend div.el-select:hover .el-input__inner {
    text-align: center;
  }
  
}
</style>